$(document).ready(function () {
    var SimPayment = {
        $form: null,
        $amountHolder: null,
        $simIdHolder: null,
        $amountOutputHolder: null,
        $simOutputHolder: null,
        $alertText: null,
        $alertMessage: null,
        $firstName: null,
        $lastName: null,
        init: function () {
            this.initDomVariables();
            this.initValidator();
            this.initStepper();
            this.bindEvents();
        },
        initDomVariables: function () {
            this.$form = $('#rechargeSimForm');
            this.$amountHolder = $('#card_holder_payment');
            this.$simIdHolder = $('#id_sim');
            this.$amountOutputHolder = $('#total-payment');
            this.$simOutputHolder = $('#bought-sim');
            this.$alertMessage = $('.alert-message');
            this.$alertText = $('.alert-text');
        },
        initValidator: function () {
            var self = this;
            $.validator.addMethod('phoneValidation', function (phone_number, element) {
                return this.optional(element) || phone_number.length > 9 && phone_number.match(/^[0-9 . \/]+$/);
            }, 'Please specify a valid phone number');
            self.$form.validate();
            $('.phone_number').rules('add', {
                phoneValidation: true
            });
        },
        initStepper: function () {
            var self = this;
            self.$alertText.html('');
            self.$form.steps({
                headerTag: 'h3',
                bodyTag: 'fieldset',
                transitionEffect: 'slideLeft',
                autoFocus: true,
                onStepChanging: function (event, currentIndex, newIndex) {
                    if (currentIndex === 0) {
                        var canMoveToNextStep = false;
                        if (self.$form.valid()) {
                            $.ajax({
                                type: 'POST',
                                url: '/create-update-client',
                                async: false,
                                data: self.$form.serialize(),
                                success: function (response) {
                                    if (response.status === 'success') {
                                        self.$alertMessage.removeClass('alert-warning alert-danger').addClass('alert-success').show();
                                        self.$alertText.html(response.message);
                                        $('#id_client').val(response.data.client_id);
                                        self.copyClientNameToPaymentInfo();
                                        canMoveToNextStep = true;
                                    } else {
                                        self.$alertMessage.removeClass('alert-warning alert-success').addClass('alert-danger').show();
                                        self.$alertText.html(response.message);
                                        $('#id_client').removeAttr('value');
                                    }
                                },
                                error: function () {
                                    self.$alertMessage.removeClass('alert-warning alert-success').addClass('alert-danger').show();
                                    self.$alertText.html('Server error!');
                                    $('#id_client').removeAttr('value');
                                }
                            });
                        }
                        return canMoveToNextStep;
                    }
                    self.$alertMessage.hide();
                    if (currentIndex > newIndex) {
                        return true;
                    }
                    self.$form.validate().settings.ignore = ":disabled,:hidden";
                    return self.$form.valid();
                },
                onFinishing: function () {
                    self.$alertText.html('');
                    var buttonPrev = $('.actions > ul > li').first();
                    var buttonFinish = $('.actions > ul > li').last();
                    buttonPrev.hide();
                    buttonFinish.hide();
                    self.$alertMessage.removeClass('alert-danger alert-success').addClass('alert-warning').show();
                    self.initDomVariables();
                    self.$alertText.html('The payment is being processed... Please wait!');
                    self.initStripe(function () {
                        $.ajax({
                            type: 'POST',
                            url: '/add-sim-payment',
                            data: self.$form.serialize(),
                            success: function (data) {
                                if (data.status === 'success') {
                                    self.$alertMessage.removeClass('alert-danger alert-warning').addClass('alert-success').show();
                                    self.$alertText.html(data.message);
                                    setTimeout(function () {
                                        self.clearView();
                                        $.modal.close();
                                        self.$alertMessage.hide();
                                        buttonPrev.show();
                                        buttonFinish.show();
                                    }, 2200);
                                } else {
                                    self.$alertMessage.removeClass('alert-success alert-warning').addClass('alert-danger').show();
                                    self.$alertText.html(data.message);
                                    buttonPrev.show();
                                }
                            },
                            error: function () {
                                self.$alertMessage.removeClass('alert-success alert-warning').addClass('alert-danger').show();
                                self.$alertText.html("Server error!");
                                buttonPrev.show();
                                buttonFinish.show();
                            }
                        });
                    });
                }
            });
        },
        bindEvents: function () {
            var self = this;

            $('.section-sim-recharge ul.n-trip-list li button.n-btn').on('click', function () {
                var price = $(this).data('price');
                var simId = $(this).data('simid');
                var simName = $(this).data('sim');
                self.onSimRechargeWizardStarting(price, simName, simId);
            });

            if(!isTouchDevice()) {
                $('.sim-details').on('click', function () {
                    var $btn = $(this).find('button.n-btn');
                    var price = $btn.data('price');
                    var simId = $btn.data('simid');
                    var simName = $btn.data('sim');
                    self.onSimRechargeWizardStarting(price, simName, simId);
                });
            }
        },
        onSimRechargeWizardStarting: function(price, simName,simId) {
            $('#rechargeSimModal').modal('show');
            this.initDomVariables();
            this.$amountHolder.val(price);
            this.$simIdHolder.val(simId);
            this.$amountOutputHolder.html(price);
            this.$simOutputHolder.html(simName);
        },
        clearView: function () {
            this.$form.find('input').val('');
        },
        copyClientNameToPaymentInfo: function() {
            var firstname = $('#prenume_client').val();
            var lastname = $('#nume_client').val();
            $('#card_holder_first_name').val(firstname);
            $('#card_holder_last_name').val(lastname);
        },
        initStripe: function (callback) {
            var self = this;
            var date = $("#expiration_date").val().split('-');
            var month = date[1];
            var year = date[0];
            var name = $('#card_holder_first_name').val() + " " + $('#card_holder_last_name').val();
            Stripe.setPublishableKey(stripe_pb_key);
            Stripe.createToken({
                    number: $('#card_number').val(),
                    cvc: $('#cvv').val(),
                    exp_month: month,
                    exp_year: year,
                    name: name
                },
                function stripeResponseHandler(status, response) {
                    if (response.error) {
                        var buttonPrev = $('.actions > ul > li').first();
                        self.$alertMessage.removeClass('alert-success alert-warning').addClass('alert-danger').show();
                        self.$alertText.html(response.error.message);
                        buttonPrev.show();
                    }
                    else {
                        var token = response['id'];
                        self.$form.find("input[type=hidden]#stripeToken").remove();
                        self.$form.append("<input type='hidden' name='stripeToken' id='stripeToken' value='" + token + "'/>");
                        callback();
                    }
                });
        }
    };
    if (window.location.pathname === '/sim-recharge') {
        SimPayment.init();
    }
});
